import { Helmet } from "react-helmet";
import { Container } from "reactstrap";

import { Heading } from "components/Heading";
import PaymentsAndLicensing from "../tabs/PaymentsAndLicensing";
import useMcapFilters from "../useMcapFilters";
import typography from "../typography";

export default function PaymentsAndLicensingScreen() {
  const { filters, renderFilterBar } = useMcapFilters();

  return (
    <div className="page-content">
      <Helmet>
        <title>{typography.TAB_PAYMENTS_LICENSING} · MCAP</title>
      </Helmet>
      <Container fluid className="mcap-hub">
        <Heading heading={typography.TAB_PAYMENTS_LICENSING} />
        {/* The CSV lives on each drill-down instead of the filter bar: the
            useful export here is the rows behind a number, not a summary. */}
        <PaymentsAndLicensing filterBar={renderFilterBar(null)} filters={filters} />
      </Container>
    </div>
  );
}
